import type { ComboboxProps } from "metabase/ui";

export const MIN_WIDTH = 300;
export const WIDTH = 380;
export const COMBOBOX_PROPS: Partial<ComboboxProps> = {
  width: 314,
  position: "bottom-start",
};
